import type { PDFConvertFunction } from "@pdfking/renderer-api"
import { BlobToUint8, IterableToArray, ToBlob } from "@pdfking/tfunc"

import { BytesToPdf } from "../utils/BytesToPdf"

export const PDFConvert: PDFConvertFunction = async (input, resolution) => {
  const bytes = await IterableToArray(input.stream).then(ToBlob).then(BlobToUint8)

  const { pdf, trim_box, media_box } = await BytesToPdf(bytes, input.type, resolution)

  const blob = await pdf.save().then(bytes => ToBlob(bytes, "application/pdf"))

  return { blob, trim_box, media_box }
}
